import { flow, getOr, without, get, first, map, flatten, mergeAll } from 'lodash/fp';
import { CLOSE_ESTIMATE } from './actionTypes';
import addEstimateToSelection from './share/addEstimateToSelection';
import initShareStore from './share/initShareStore';
import { removeDesignFromJob } from '../api/mandi';
import controlNewDesignModal from './uiState/controlNewDesignModal';

const closeEstimate = (estimateId, containerIds, itemIds, nextEstimate) => ({
  type: CLOSE_ESTIMATE,
  payload: {
    estimateId,
    containerIds,
    itemIds,
    nextEstimate,
  },
});

const defaultOptions = {
  disassociate: false,
};

export default (designId, options = {}) => async (dispatch, getState) => {
  const { disassociate } = mergeAll([defaultOptions, options]);
  const { estimateBuilder } = getState();
  const { estimates, containers } = estimateBuilder.entities;
  const design = get(`byId.${designId}`, estimates);

  if (design) {
    const containerIds = design.containers;

    const designCount = get('allIds.length', estimates);
    if (designCount === 1) {
      dispatch(controlNewDesignModal({ newDesignModalOpen: true }));
    }

    const nextEstimate = flow(
      get('estimateBuilder.entities.estimates.allIds'),
      without([designId]),
      first,
    )(getState());

    if (designCount > 1) {
      dispatch(initShareStore());
      dispatch(addEstimateToSelection(nextEstimate));
    }

    const itemIds = flow(
      get('containers'),
      map(containerId => get(`byId.${containerId}`, containers)),
      map('items'),
      flatten,
    )(design);

    dispatch(closeEstimate(designId, containerIds, itemIds, nextEstimate));
    if (disassociate && getOr(false, 'attributes.isMandi', design)) {
      removeDesignFromJob(get('attributes.jobUid', design), design.designId);
    }
  }
};
